import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { messagesApi } from "../../features/messages/messagesApi";
import Message from "./Message";

const Messages = ({ messages = [], totalCount }) => {
    const { id } = useParams();
    const { user } = useSelector((state) => state.auth) || {};
    const { email } = user || {};
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const dispatch = useDispatch();

    const fetchMore = () => {
        setPage((prevPage) => prevPage + 1);
    };

    useEffect(() => {
        if (page > 1) {
            dispatch(
                messagesApi.endpoints.getMoreMessages.initiate({
                    id,
                    page,
                })
            );
        }
    }, [dispatch, page, id]);

    // decide hasMore is true or false
    useEffect(() => {
        if (totalCount > 0) {
            const more =
                Math.ceil(
                    totalCount / Number(process.env.REACT_APP_MESSAGES_PER_PAGE)
                ) > page;
            setHasMore(more);
        }
    }, [page, totalCount]);

    return (
        <div
            id="scrollableDiv"
            className="relative w-full p-6 h-[calc(100vh_-_197px)] flex flex-col-reverse overflow-y-auto"
        >
            <ul className="space-y-2">
                <InfiniteScroll
                    dataLength={messages.length}
                    next={fetchMore}
                    inverse={true}
                    hasMore={hasMore}
                    loader={<h4 className="text-center">Loading...</h4>}
                    scrollableTarget="scrollableDiv"
                >
                    {messages
                        ?.slice()
                        ?.sort((a, b) => a.timestamp - b.timestamp)
                        ?.map((message) => {
                            const { message: lastMessage, id } = message || {};

                            const justify =
                                message?.sender?.email !== email
                                    ? "start"
                                    : "end";

                            return (
                                <li
                                    key={id}
                                    className={`flex justify-${justify} my-1`}
                                >
                                    <Message message={lastMessage} />
                                </li>
                            );
                        })}
                </InfiniteScroll>
            </ul>
        </div>
    );
};

export default Messages;
